import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private lang$ = new BehaviorSubject<'TH' | 'EN'>(
    (localStorage.getItem('lang') as 'TH' | 'EN') || 'TH'
  );

  get currentLang$() {
    return this.lang$.asObservable();
  }

  setLang(lang: 'TH' | 'EN') {
    localStorage.setItem('lang', lang);
    this.lang$.next(lang);
  }

  switchLang() {
    const current = this.lang$.value;
    const newLang = current === 'TH' ? 'EN' : 'TH';
    this.setLang(newLang);
  }
}
